<template>
	<article class="d-recycling-sorting-abc-page-custom">
		<PageHero v-bind="{ ...header, breadcrumb }" />
		<div
			class="
				d-recycling-sorting-abc-page-custom--content
				bg-primary
				pb-xl
				px-layout-margin
			"
		>
			<BaseInputText
				v-model="textValue"
				class="w-full flex-grow border-2 rounded-full border-primary"
				placeholder="Skriv det affald du vil sortere"
				@keypress="() => getSuggestions(textValue)"
				@keyup.delete="() => getSuggestions(textValue)"
			>
				<template #button>
					<button
						:class="[
							'absolute top-1/2 right-8',
							'transform -translate-y-1/2',
							'rounded-full bg-extra w-40 h-40',
							'flex justify-center items-center',
						]"
						aria-label="Søg efter nyheder"
						@click="() => getSuggestions(textValue)"
					>
						<SvgSearch class="w-16 h-16 text-white" />
					</button>
				</template>
			</BaseInputText>
			<div
				v-if="items && items.length > 0"
				class="
					bg-white
					pt-md
					-mt-md
					rounded-lg
					overflow-x-scroll
					max-h-250
					mx-2
				"
			>
				<div
					v-for="item in items"
					:key="item.id"
					class="py-xs px-sm hover:bg-primary-light cursor-pointer"
					@click="() => getContent(item.id)"
				>
					{{ item.name }}
				</div>
			</div>
			<div
				v-if="card"
				class="
					rounded-lg
					bg-white
					flex
					mt-sm
					overflow-hidden
					p-sm
					<1024:flex-col <1024:w-full
				"
			>
				<!-- 				<UmbracoImageExt
				v-if="card.category && card.category.image"
				:widths="[320, 480, 640, 480 * 2, 640 * 2]"
				:alt="card.name"
				:source-url="card.category.image"
				:source-width="1200"
				:source-height="1800"
				:aspect-ratio="1.5"
				class=">=1024:w-1/2 rounded-lg <1024:mb-sm >=1024:mr-lg"
			/> -->
				<img
					v-if="card.category && card.category.image"
					:src="card.category.image"
					:alt="card.name"
					class="
						>=1024:w-1/2
						w-full
						rounded-lg
						<1024:mb-sm
						>=1024:mr-lg
					"
					style="height: auto"
				/>
				<div class="flex flex-col justify-center >=1024:w-1/2">
					<BaseH1
						v-if="card.name"
						tag="h2"
						class="mb-sm"
						v-text="card.name"
					/>
					<div class="text-h2">Afleveres</div>
					<div v-if="card.home" class="mt-sm">
						<div class="text-h3">Hjemme</div>
						<div
							class="text-body mt-8"
							v-html="card.home.header"
						></div>
						<div
							class="s-rich-text mt-8"
							v-html="card.home.body"
						></div>
						<div v-if="card.home.link" class="mt-xs">
							<NuxtLinkExt
								class="inline-block"
								:to="card.home.link.url"
								target="_blank"
							>
								<BaseButton tag="div">
									<template #icon>
										<SvgExternalArrowIcon
											class="w-16 h-16"
										/>
									</template>
									<template #default>Læs mere</template>
								</BaseButton>
							</NuxtLinkExt>
						</div>
					</div>
					<div v-if="card.recyclingStation" class="mt-sm">
						<div
							class="text-h3"
							v-html="card.recyclingStation.header"
						></div>
						<div
							class="s-rich-text mt-8"
							v-html="card.recyclingStation.body"
						></div>
						<div v-if="card.recyclingStation.link" class="mt-xs">
							<NuxtLinkExt
								class="inline-block"
								:to="card.recyclingStation.link.url"
								target="_blank"
							>
								<BaseButton tag="div">
									<template #icon>
										<SvgExternalArrowIcon
											class="w-16 h-16"
										/>
									</template>
									<template #default>Læs mere</template>
								</BaseButton>
							</NuxtLinkExt>
						</div>
					</div>
				</div>
			</div>
			<BlockList :block-list="contentElements" />
		</div>
	</article>
</template>

<script>
import PageHero from '~/components/main/PageHero';
import SvgSearch from '~/assets/svgs/search-icon.svg?inline';
import BlockList from '~/components/main/BlockList';
import SvgExternalArrowIcon from '~/assets/svgs/external-arrow-icon.svg?inline';

export default {
	name: 'MainRecyclingSortingAbcPageCustom',
	components: { PageHero, SvgSearch, BlockList, SvgExternalArrowIcon },
	inheritAttrs: false,
	props: {
		title: String,
		header: {
			type: Object,
			default: () => ({}),
		},
		breadcrumb: {
			type: Array,
			required: false,
		},
		contentElements: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			textValue: '',
			items: null,
			card: null,

			error: '',
		};
	},
	methods: {
		getSuggestions(textValue) {
			this.$axios
				.get(
					`/api/recyclingsortingabc/GetSuggestions?text=${textValue}`
				)
				.then((response) => {
					this.items = response.data.items;
				})
				.catch((error) => {
					this.error = error;
					console.error(error);
				});
		},
		getContent(id) {
			this.$axios
				.get(`/api/recyclingsortingabc/GetContent?id=${id}`)
				.then((response) => {
					this.card = response.data;
					this.textValue = this.card.name;
					this.items = null;
				})
				.catch((error) => {
					this.error = error;
					console.error(error);
				});
		},
	},
};
</script>

<style>
.d-recycling-sorting-abc-page-custom
	> .d-recycling-sorting-abc-page-custom--content
	> .c-block-list
	> .c-block-list-rte-custom {
	@apply w-8col !important;
}
</style>
